import { render, staticRenderFns } from "./VeBlockHost.vue?vue&type=template&id=88afb752"
import script from "./VeBlockHost.vue?vue&type=script&lang=js"
export * from "./VeBlockHost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports